import { Construction } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { pickByLanguage } from "@/lib/language";

interface UnderMaintenancePageProps {
  username?: string;
}

export function UnderMaintenancePage({ username }: UnderMaintenancePageProps) {
  const { language } = useLanguage();
  const t = (pt: string, en: string) => pickByLanguage(language, { pt, en });

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-8">
      {/* Background decoration */}
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 h-[500px] w-[500px] rounded-full bg-primary/5 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-[300px] w-[300px] rounded-full bg-primary/5 blur-2xl" />
      </div>

      <div className="relative flex flex-col items-center text-center max-w-sm">
        {/* Icon */}
        <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-primary/10 ring-1 ring-primary/15 shadow-sm">
          <Construction className="h-10 w-10 text-primary" strokeWidth={1.5} />
        </div>

        {/* Username badge */}
        {username && (
          <span className="mb-4 inline-flex items-center rounded-full border border-border bg-muted px-3 py-1 text-xs font-medium tracking-wide text-muted-foreground">
            @{username}
          </span>
        )}

        {/* Heading */}
        <h1 className="text-[1.6rem] font-bold tracking-tight leading-[1.15] text-foreground text-balance">
          {t("Em manutenção", "Under Maintenance")}
        </h1>

        {/* Subtext */}
        <p className="mt-3 text-[0.95rem] leading-relaxed text-muted-foreground text-balance">
          {t(
            "Esta página está sendo preparada pelo seu criador e ficará disponível em breve. Volte mais tarde!",
            "This page is being set up by its creator and will be available soon. Check back later!",
          )}
        </p>

        {/* Divider */}
        <div className="my-8 h-px w-16 bg-border" />

        {/* CTA */}
        <p className="text-[11px] uppercase tracking-wide text-muted-foreground">
          {t("Quer criar a sua página?", "Want to create your own page?")}{" "}
          <Link
            to="/"
            className="font-semibold text-primary underline-offset-2 hover:underline"
          >
            {t("Comece grátis →", "Start for free →")}
          </Link>
        </p>
      </div>
    </div>
  );
}
